import { gql } from '@apollo/client';
import { INVOICE_FIELDS } from './invoice.fields';
import { DEPARTMENT_DETAIL_FIELDS } from '../department';
import { BILLING_DETAIL_FIELDS } from '../billing';
import { CLIENT_DETAIL_FIELDS } from '../client';
import { STAFF_FIELDS } from '../staff';
import { ITEM_FIELDS } from '../item';

export const INVOICE_DETAIL_FIELDS = gql`
  ${BILLING_DETAIL_FIELDS}
  ${CLIENT_DETAIL_FIELDS}
  ${DEPARTMENT_DETAIL_FIELDS}
  ${INVOICE_FIELDS}
  ${ITEM_FIELDS}
  ${STAFF_FIELDS}
  fragment InvoiceDetailFields on Invoice {
    ...InvoiceFields
    department {
      ...DepartmentDetailFields
    }
    client {
      ...ClientDetailFields
    }
    billing {
      ...BillingDetailFields
    }
    owner {
      ...StaffFields
    }
    items {
      ...ItemFields
    }
  }
`;
